import React, { useContext } from 'react';
import moment, { Moment as MomentType } from 'moment';
import { SingleDatePicker } from 'react-dates';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CalendarIcon from '@wix/da-ds/pkg/Icons/Calendar';
import ArrowDown from '@wix/da-ds/pkg/Icons/16x16/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HeaderDropdowns from './HeaderDropdowns';

import s from './react-date.overrides.scss';

const DATE_PICKER_FORMAT = 'MMMM D, YYYY';
const maxDate = new Date();
maxDate.setFullYear(maxDate.getFullYear() + 5);

export interface Props {
  id: string;
  date?: moment.Moment;
  placeholder?: string;
  isFocused?: boolean;
  className?: string;
  isOutsideRange?: (dateToCheck: MomentType) => boolean;
  onDateChange: (newDate: moment.Moment) => void;
  onFocusChange: (props: { focused: boolean }) => void;
  disabled?: boolean;
  dropDirection?: 'up' | 'down';
}

const DatePickerPopup: React.FC<Props> = ({
  id,
  date,
  placeholder,
  className,
  isFocused,
  isOutsideRange,
  onDateChange,
  onFocusChange,
  disabled,
  dropDirection = 'down',
}) => {
  const isMobile = useContext(MobileContext);
  const selectedDate = date ? moment(date) : null;

  return (
    <div
      className={cn(
        s['root'],
        dropDirection === 'up' && s['up'],
        disabled && s['disabled'],
        className
      )}
    >
      <SingleDatePicker
        date={selectedDate}
        onDateChange={onDateChange}
        onFocusChange={onFocusChange}
        focused={isFocused}
        id={id}
        displayFormat={DATE_PICKER_FORMAT}
        numberOfMonths={1}
        transitionDuration={0}
        isOutsideRange={isOutsideRange}
        block={false}
        customInputIcon={<CalendarIcon size={IconSize.SMALL} />}
        renderMonthElement={props => <HeaderDropdowns {...props} />}
        daySize={40}
        placeholder={placeholder}
        readOnly={!isMobile}
      />
      <ArrowDown
        className={s['arrow-icon']}
        size={IconSize.SMALLER}
        disableDefaultColors
      />
    </div>
  );
};
DatePickerPopup.displayName = 'DatePickerPopup';

export default DatePickerPopup;
